export default {
    data: () => ({
        translations: {
            title: {
                el: "Ρυθμίσεις Viber",
                en: "Viber Configuration",
                it: "Configurazione di Viber"
            },
            aliasExists: {
                el: "Yπάρχει ήδη viber για αυτή την εταιρεία",
                en: 'There is already a viber account on this company.',
                it: "C'è già viber per questa azienda."
            },
            aliasRequested1: {
                el: "Μια αίτηση με το όνομα ",
                en: 'An application with name ',
                it: "È già stata presentata "
            },
            aliasRequested2: {
                el: " έχει ήδη γίνει και περιμένουμε την έγκρισή της.",
                en: ' has already been made and we are waiting for it to be approved.',
                it: " e siamo in attesa della sua approvazione."
            },
            senderAliasName: {
                el: "Ψευδώνυμο αποστολέα",
                en: "Sender Alias Name",
                it: "Nome alias mittente"
            },
            actionConfirm: {
                el: "Έγκριση",
                en: "Approve",
                it: "Approvare"
            },
            actionCancel: {
                el: "Ακύρωση",
                en: "Cancel",
                it: "Annullamento"
            },
            actionRequest: {
                el: "Αίτηση",
                en: "Request",
                it: "Richiesta"
            },
            
            actionConfirmDialog: {
                el: "Έγκριση",
                en: "Approve",
                it: "Approvare"
            },
            actionCancelDialog: {
                el: "Διαγραφη",
                en: "Delete",
                it: "Cancellare"
            },
            actionRequestDialog: {
                el: "Υποβολη",
                en: "Submit",
                it: "Invia"
            },
            close: {
                el: "Κλείσιμο",
                en: "Close",
                it: "Chiudere"
            },
            actionQuestion1: {
                el: "Είστε σίγουροι ότι θέλετε να γίνει",
                en: "Are you sure you want to ",
                it: "Sei sicuro di voler"
            },
            actionQuestion2: {
                el: " για το ψευδόνυμο ",
                en: " the alias name ",
                it: " il nome dell'alias "
            },
            
            successConfirm: {
                el: "Έχετε εγκρίνει με επιτυχία το ψευδώνυμο ",
                en: "You have successfully approved the alias ",
                it: "Avete approvato con successo l'alias "
            },
            successRequest: {
                el: "Έχετε αιτηθεί επιτυχώς το ψευδώνυμο ",
                en: "You have successfully requested the alias ",
                it: "Hai richiesto con successo l'alias "
            },
            
            successCancel: {
                el: "Διαγράψατε επιτυχώς το ψευδώνυμο ",
                en: "You have successfully deleted the alias ",
                it: "È stato cancellato l'alias "
            },
        }
    })
};
